import React, { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useLocalStorage } from '../../hooks/useLocalStorage';

const LoginAsContact = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [payload, setPayload] = useLocalStorage('user-payload', params.payload);
    //alert(params.payload);
    useEffect(() => {
        setPayload(params.payload);
        setTimeout(() => {
            navigate('/', { replace: true });
        }, 10);
    }, []);

    return <></>;
};

export { LoginAsContact };
